<template>
  <div class="socialDetail" id="tinyScreenSocialDetail">
    <Header></Header>
      <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>
    <!-- section1 -->
    <div class="section1 middle">
      <div class="container">
        <div class="crumbs">
          <span @click="goJob">{{$t('socialDetail.title')}}</span>
          <span><img src="../../assets/picture/occupation/more.png"></span>
          <span>{{$t('socialDetail.introduce')}}</span>
        </div>
        <div class="detailBox">
          <div class="title">
          {{detail.title}}
          </div>
          <p class="dec" v-html="detail.responsibilities"></p>
          <div>
            <div class="subTitle">
              <i></i>
              <span>{{$t('socialDetail.requetion')}}</span>
            </div>
            <p class="requirements" v-html="detail.requirements"></p>
          </div>
          <div>
             <div class="subTitle">
              <i></i>
              <span>{{$t('socialDetail.location')}}</span>
            </div>
            <p v-if="lang=='en'" class="enTxt">{{detail.location}}</p>
            <p v-else class="cnTxt">{{detail.location}}</p>
          </div>
          <div class="subTitle">
            <i></i>
            <span>{{$t('socialDetail.mode')}}</span>
          </div>
          <div v-if="lang=='en'">
            <p class="enTxt">{{$t('socialDetail.tip1')}}{{email}}</p>
            <p class="enTxt mb60">{{$t('socialDetail.tip2')}}</p>
          </div>
          <div v-else>
            <p class="cnTxt">{{$t('socialDetail.tip1')}}{{email}}</p>
            <p class="cnTxt mb60">{{$t('socialDetail.tip2')}}{{detail.location}}{{$t('socialDetail.tip3')}}</p>
          </div>
         <!--  <div v-if="lang=='en'">
            <p>{{$t('socialDetail.send')}}</p>
          </div> -->
           <!-- <div v-else>
            <p>{{$t('socialDetail.send')}}{{email}}</p>
            <p>{{$t('socialDetail.format')}}：{{detail.title}}</p>
          </div> -->
        </div>      
        <div v-if="detail.canApply == 1 && lang!='en'" @click="goApplyPage" class="applyBtn">
          {{$t('socialDetail.submit')}}
        </div>
         <div v-if="detail.canApply == 1 && lang=='en'" @click="goApplyPage" class="applyBtnEn">
          {{$t('socialDetail.submit')}}
        </div>
      </div>
    </div>
    <!-- section2 -->
    <Code></Code>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import Code from '../common/code';
export default {
  data() {
    return {
      title:'',
      liIndex:-1,
      jodId:'',
      isShowSearch:false,
      detail:[],
      lang:'',
      email:'',
      bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      }  
    };
  },
  components: { Header,Footer,Code },
  mounted(){
    this.jodId = this.$route.query.id;
    this.lang = window.sessionStorage.getItem("language");
    this.getJobById();
    this.getAdvert();
    this.getConfig();
  },
  methods: {
    //获取基础配置信息
    async getConfig() {
        const { data: res } = await this.$http.get("/config/getConfig.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.email = res.data.email;
      },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    // 根据ID获取职位分类
    async getJobById(id) {
        const { data: res } = await this.$http.get("/job/getJobById.do?id="+this.jodId);
        if (res.code !== 200) return this.$message.error(res.message);
        this.detail = res.data;
        console.log(this.detail,'this.detail');
        this.title = res.data.title;
    },
    goJob(){
      this.$router.push({  
            path: '/positions'
        }) 
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=7");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
    // 跳转岗位申请页面
    goApplyPage(){
       this.$router.push({
         path: '/apply',
         query: {
           title: this.title,
           jodId:this.jodId
         }
       })
    }
  }
};
</script>

<style lang="less" scoped>
.socialDetail{
  /deep/ .dec{
    p{
      margin:0 !important;
    }
  }
  /deep/ .requirements{
    p{
      margin-bottom:0 !important;
    }
  }
  .cnTxt{
    font-size: 14px;
    line-height: 2em;
    margin-bottom: 0;
  }
  .enTxt{
    font-size: 16px;
    line-height: 2em;
    margin-bottom: 0;
  }
  .tipTxt{
    color:#353535;
    font-size: 14px;
  }
  .bannerBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{
        margin-top: 170px;
       }
    }
  }
  /*********************************************/
  .section1{
    padding-bottom: 120px;
    .crumbs{
      padding:40px 0 14px 0;
      border-bottom: 1px solid #D5D5D5;
      display: block;
      span{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
        line-height: 28px;
        letter-spacing: 1px;
        margin-right: 23px;
        cursor: pointer;
        img{
          width: 14px;
          height: 14px;
        }
      }
    }
    .applyBtn{
        margin:0 auto;
        display: block;
        width: 224px;
        height: 44px;
        text-align: center;
        color:#fff;
        background: #900211;
        font-size: 14px;      
        letter-spacing: 10px;
        line-height: 44px;
        cursor: pointer;
      }
    .applyBtnEn{
      margin:0 auto;
      display: block;
      width: 224px;
      height: 44px;
      text-align: center;
      color:#fff;
      background: #900211;
      font-size: 14px;      
      line-height: 44px;
      cursor: pointer;
      margin-bottom: 50px;
    }
    .detailBox{
      padding-top: 80px;
      .title{
        text-align: center;
        font-size: 35px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #353535;
        line-height: 49px;
        letter-spacing: 2px;
        margin-bottom: 52px;
      }
      .dec{
        margin-bottom: 30px;
        p,span{
          font-size: 14px;
          margin: 0;
        }
      }
      .subTitle{
        margin-bottom: 18px;
        position: relative;
        i{
          display: inline-block;
          width: 4px;
          height: 22px;
          background: #900211;
          position: absolute;
          top: 4px;
        }
        span{
          margin-left: 10px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #900211;
          line-height: 28px;
          letter-spacing: 1px;
        }
      }
      p{        
        /*font-size: 14px;*/
       /* font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #353535;
        line-height: 32px;
        letter-spacing: 0.88px;*/
      }
      p:last-of-type{
        margin-bottom: 40px;
      }
      .mb60{
        margin-bottom: 60px !important;
      }
    }
  }
}
</style>
